import { notification } from 'antd';
import { useMutation } from 'react-query';
import { workOrderReportServices } from './workOrderReport.services';
import notificationError from '@/utils/functions/notificationError';

export function useGenerateWorkOrderVehicleHistory() {
  return useMutation(workOrderReportServices.vehicleHistory, {
    onSuccess() {
      notification.success({
        message: 'Sucesso!',
        description: `Histórico de veículo gerado com Sucesso!`,
      });
    },
    onError(error) {
      notificationError(error);
    },
  });
}

export function useGenerateWorkOrderByInvoice() {
  return useMutation(workOrderReportServices.byInvoice, {
    onSuccess() {
      notification.success({
        message: 'Sucesso!',
        description: `OS x Nota Fiscal gerado com Sucesso!`,
      });
    },
    onError(error) {
      notificationError(error);
    },
  });
}

export function useWorkOrderPaymentReceipt() {
  return useMutation(workOrderReportServices.paymentReceipt, {
    onSuccess() {
      notification.success({
        message: 'Recibo gerado com sucesso',
        description:
          'Recibo de pagamento da ordem de serviço gerado com sucesso!',
      });
    },
    onError(error) {
      notificationError(error);
    },
  });
}
